import { c as _c } from "react/compiler-runtime";
import { Loader } from 'shared/components';
function TabContentLoader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center py-12"><Loader className="scale-150" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { TabContentLoader };